import React from 'react'
import PropTypes from 'prop-types'
import { FlatButton } from 'material-ui'

const ModalActions = ({
  closeModal,
  handleSwitchPage,
  hasTimeRange,
  isTops,
  isOrthoTrac,
  selectedApptTypes,
  selectedPatientStatuses,
  submitModal,
  page,
}) => (
  <div>
    {/*
      OrthoTrac doesn't give us real patient_statuses
      so they only get the first page
    */}
    {page === 0 && (
      <div>
        <FlatButton
          label="Cancel"
          key={'close'}
          secondary
          onClick={closeModal}
        />
        <FlatButton
          label={isOrthoTrac ? 'Ok' : 'Next'}
          key={isOrthoTrac ? 'submit' : 'next'}
          primary
          disabled={isOrthoTrac && !selectedApptTypes.length}
          onClick={isOrthoTrac
            ? submitModal
            : () => handleSwitchPage('next')
          }
        />
      </div>
    )}
    {page === 1 && (
      <div>
        <FlatButton
          label="Cancel"
          key={'close'}
          secondary
          onClick={closeModal}
        />
        {hasTimeRange && <FlatButton
          label="Back"
          key={'back'}
          secondary
          onClick={() => handleSwitchPage('back')}
        />}
        <FlatButton
          label={isTops ? 'Ok' : 'Submit'}
          key={'submit'}
          primary
          disabled={
            !selectedApptTypes.length && !selectedPatientStatuses.length
          }
          onClick={submitModal}
        />
      </div>
    )}
  </div>
)

ModalActions.propTypes = {
  closeModal: PropTypes.func.isRequired,
  handleSwitchPage: PropTypes.func.isRequired,
  hasTimeRange: PropTypes.bool.isRequired,
  isTops: PropTypes.bool,
  isOrthoTrac: PropTypes.bool.isRequired,
  selectedApptTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatuses: PropTypes.arrayOf(PropTypes.string).isRequired,
  submitModal: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
}

export default ModalActions



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/BlastMessageFiltersModal/ModalActions.js